<template>
  <div>
    <div class="label-clear-container">
      <div class="label">{{ label }}</div>
      <button id="clear" class="clear" @click="handleClear">
        {{ t("SHARED.CLEAR") }}
      </button>
    </div>
    <div class="signature-pad-container">
      <div v-show="!signed" class="sign-here">{{ t("SHARED.SIGNHERE") }}</div>
      <div class="row">
        <div class="col-12 pb-2">
          <VueSignaturePad
            ref="signaturePadRef"
            class="signature-pad"
            :options="{ onEnd: handleESign }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { ref, Ref } from "vue";
import { VueSignaturePad } from "vue-signature-pad";

defineProps({
  label: String,
});

const emit = defineEmits(["clear", "eSign"]);

const { t } = useI18n();

const signed = ref(false);
const signaturePadRef = ref() as Ref<typeof VueSignaturePad>;

const handleESign = () => {
  signed.value = true;
  const { data } = signaturePadRef.value.saveSignature();
  emit("eSign", data);
};

const handleClear = () => {
  signaturePadRef.value.clearSignature();
  signed.value = false;
  emit("clear");
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.label-clear-container {
  display: flex;
}

.label {
  margin-top: 4px;
  margin-left: 14px;
  font-size: 16px;
  font-weight: bold;
}
.clear {
  margin-top: 4px;
  margin-left: auto;
  padding-right: 14px;
  position: relative;
  font-size: 16px;
  text-decoration: none;
  color: $pj-color-green;
  font-weight: 600;
  background: none;
  border: none;
  width: fit-content;
}
.clear:hover {
  font-weight: 700;
}

.signature-pad {
  background-color: #e0ffe9;
  border: 3px solid $pj-color-green;
  border-radius: 8px;
  min-height: 240px;
  max-height: 240px;
  opacity: 0.85;
}

.signature-pad-container {
  position: relative;
  user-select: none;
}

.signature-pad-container.row {
  position: absolute;
  z-index: 99;
}

.sign-here {
  position: relative;
  text-align: center;
  height: 0;
  top: 80px;
  font-weight: 600;
  font-size: 54px;
  color: black;
}
</style>
